module.exports = __webpack_public_path__ + "img/youshi11.209c974e.png";